/**
 * Quick action buttons configuration for underway phase
 */

import { 
  MapPin, Cloud, Navigation, Radio, 
  AlertOctagon, Users, AlertTriangle, 
  Eye, Wrench 
} from 'lucide-react';

export const getQuickActions = (vesselType, setActiveModal, setRadioData, radioData) => {
  const quickActions = [
    {
      icon: MapPin,
      label: 'Position',
      description: 'GPS or manual entry',
      action: () => setActiveModal('position'),
      essential: true,
      frequency: 'Every 4 hours at sea'
    },
    {
      icon: Cloud,
      label: 'Weather',
      description: 'Manual or API data',
      action: () => setActiveModal('weather'),
      essential: vesselType !== 'inland',
      frequency: 'Every watch'
    },
    {
      icon: Navigation,
      label: 'Course Change',
      description: 'Log course alteration',
      action: () => setActiveModal('course')
    },
    {
      icon: Radio,
      label: 'Radio Traffic',
      description: 'VTS, Port Control, etc',
      action: () => setActiveModal('radio')
    },
    {
      icon: AlertOctagon,
      label: 'Distress',
      description: 'Distress transmission',
      action: () => {
        setRadioData({ ...radioData, type: 'distress', channel: '16' });
        setActiveModal('radio');
      }
    },
    {
      icon: Users,
      label: 'Watch Change',
      description: 'Log watch handover',
      action: () => {
        const officer = prompt('Officer taking watch:');
        if (officer) {
          // This will be passed to parent via callback
          return { type: 'WATCH_CHANGE', officer };
        }
      },
      essential: vesselType === 'commercial'
    },
    {
      icon: AlertTriangle,
      label: 'Quick Incident',
      description: 'Basic report for later',
      action: () => setActiveModal('incident')
    },
    {
      icon: Eye,
      label: 'Traffic/Sighting',
      description: 'Other vessels, objects',
      action: () => {
        const sighting = prompt('What was sighted? (e.g., "Cargo vessel crossing ahead"):');
        if (sighting) {
          return { type: 'SIGHTING', sighting };
        }
      }
    },
    {
      icon: Wrench,
      label: 'Technical',
      description: 'Engine/equipment issue',
      action: () => {
        const issue = prompt('Describe technical issue:');
        if (issue) {
          return { type: 'TECHNICAL', issue };
        }
      }
    }
  ];

  // Filter actions based on vessel type  
  if (vesselType === 'inland') {
    // Minimal for inland - no weather or watch changes
    return quickActions.filter(action => 
      !['Weather', 'Watch Change'].includes(action.label)
    );
  }
  
  return quickActions;
};